import { UIHeading5 } from '@cian/ui-kit';
import { IconActionChevronRightSmall16, IconFinanceSale16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './NewbuildingPurchaseGiftSidebarTongue.css';
import { splitToAnimatedChars } from './utils/splitToAnimatedChars';

export interface INewbuildingPurchaseGiftSidebarTongueProps {
  text: string;
  onClick(): void;
}

const ICON_POP_DELAY_S = 0.24;
const CHEVRON_EXTRA_DELAY_S = 0.075;

/**
 * Оранжевый «язычок» акции под карточкой цены в сайдбаре.
 * Анимация по примеру дизайнера: блик по фону и пульс иконки, символов текста и шеврона,
 * два прогона с периодом 8 секунд после появления.
 * Реф на корневую кнопку нужен ActionAfterViewObserver без обёртки.
 */
export const NewbuildingPurchaseGiftSidebarTongue = React.forwardRef<
  HTMLButtonElement,
  INewbuildingPurchaseGiftSidebarTongueProps
>(({ text, onClick }, ref) => {
  const chars = React.useMemo(() => splitToAnimatedChars(text), [text]);
  const chevronDelay = (chars[chars.length - 1]?.delay ?? 0) + CHEVRON_EXTRA_DELAY_S;

  return (
    <button
      ref={ref}
      type="button"
      className={styles['container']}
      aria-label={text}
      data-testid="NewbuildingPurchaseGiftSidebarTongue"
      onClick={onClick}
    >
      <span className={styles['content']} aria-hidden="true">
        <span className={styles['pop']} style={{ animationDelay: `${ICON_POP_DELAY_S}s` }}>
          <IconFinanceSale16 color="icon-inverted-default" />
        </span>
        <UIHeading5 color="text-inverted-default">
          {chars.map(({ char, delay }, index) => (
            <span key={index} className={styles['pop']} style={{ animationDelay: `${delay}s` }}>
              {char}
            </span>
          ))}
        </UIHeading5>
        <span className={styles['pop']} style={{ animationDelay: `${chevronDelay}s` }}>
          <IconActionChevronRightSmall16 color="icon-inverted-default" />
        </span>
      </span>
      <span className={styles['shine']} />
    </button>
  );
});

NewbuildingPurchaseGiftSidebarTongue.displayName = 'NewbuildingPurchaseGiftSidebarTongue';
